import { scrubLogs } from 'common/log-utils';
import { getState } from 'orch-communicator/store';
import { LogPayload } from 'types/instrumentation';

const queue: LogPayload[] = [];

export default (payload: LogPayload) => {
  // Reduce network noise in development
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sdks = getState().srcSdks.loadedSdk as { [key: string]: any }; // TODO: add correct typing for loaded SDK (EMVCo APIs)

  /* START GENAI@GHCOPILOT */
  payload.CO = 'VSB_SDK_V2';
  /* START GENAI@GHCOPILOT */
  if (!payload.E) {
    payload.E = 'VSB_LOG';
  }
  /* END GENAI@GHCOPILOT */

  payload = scrubLogs(payload);
  /* END GENAI@GHCOPILOT */

  if (sdks.VISA.pushEvents) {
    try {
      sdks.VISA.pushEvents(payload);

      if (queue.length) {
        // eslint-disable-next-line no-console
        console.log('Processing queued CAL events');
        queue.forEach(event => {
          sdks.VISA.pushEvents(event);
        });

        queue.length = 0;
      }
    } catch (e: unknown) {
      // eslint-disable-next-line no-console
      console.error('Error pushing events to Visa SDK', e);
      throw new Error(e as string);
    }
  } else {
    queue.push(payload);
  }
};
